<template>
  <div>
    <div class="elements-list-nav">
      <p class="nav-label">Type:</p>

      <Button
        v-for="item in items"
        :key="item.elementTypeId"
        class="elements-list-nav-item"
        :class="{ selected: isSelected(item.elementTypeId) }"
        :disabled="loading || isSelected(item.elementTypeId)"
        @click="$emit('item-click', item.elementTypeId)"
      >
        {{ item.label }}
      </Button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ElementsListNav",

  props: {
    items: {
      default: () => [],
      type: Array,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    selectedType: {
      type: String,
      default: "",
    },
  },
  methods: {
    isSelected(elementTypeId) {
      return this.selectedType === elementTypeId;
    },
  },
};
</script>

<style scoped>
.elements-list-nav {
  @apply flex flex-wrap items-center;
  margin-top: 8px;
}

.elements-list-nav-item {
  @apply text-support-lighter p-0 mr-2 no-underline text-xs font-sans font-normal;

  &:hover {
    @apply text-brand;
  }

  &:disabled {
    @apply bg-transparent text-grey-dark;

    &:hover {
      @apply bg-grey-lightest text-grey-dark;
    }
  }

  &:last-child {
    @apply mr-0;
  }

  &:focus {
    @apply outline-none border-brand;
  }

  &.selected {
    @apply text-brand font-bold;
    cursor: s-resize;

    &:hover {
      @apply text-brand bg-transparent;
    }
  }
}

.nav-label {
  @apply mb-0 text-xs text-support-lighter mr-2;
  font-size: 12px;
}
</style>
